export default "__VITE_ASSET__B3AyihuU__"